package com.fantasytenis.shared.core.utils

import kotlinx.browser.localStorage

/**
 * Web (JS) implementation of SharedPrefs using localStorage.
 */
actual class SharedPrefs {

    companion object {
        private const val KEY_ACCESS_TOKEN = "baseline_access_token"
        private const val KEY_REFRESH_TOKEN = "baseline_refresh_token"
        private const val KEY_USER_ID = "baseline_user_id"
    }

    actual fun setAccessToken(token: String) {
        localStorage.setItem(KEY_ACCESS_TOKEN, token)
    }

    actual fun getAccessToken(): String {
        return localStorage.getItem(KEY_ACCESS_TOKEN) ?: ""
    }

    actual fun setRefreshToken(token: String) {
        localStorage.setItem(KEY_REFRESH_TOKEN, token)
    }

    actual fun getRefreshToken(): String {
        return localStorage.getItem(KEY_REFRESH_TOKEN) ?: ""
    }

    actual fun setUserId(userId: String) {
        localStorage.setItem(KEY_USER_ID, userId)
    }

    actual fun getUserId(): String {
        return localStorage.getItem(KEY_USER_ID) ?: ""
    }

    actual fun clear() {
        localStorage.removeItem(KEY_ACCESS_TOKEN)
        localStorage.removeItem(KEY_REFRESH_TOKEN)
        localStorage.removeItem(KEY_USER_ID)
    }

    actual fun hasCredentials(): Boolean {
        return getAccessToken().isNotBlank()
    }
}
